<template>
    <b-modal
        id="edit-duration-tag-modal"
        v-model="modal"
        ref="edit-duration-tag-modal"
        size="md"
        :title="$t('internship.edit_internship_duration_tag')"
        modal-class="apprentice-default-modal edit-internship-tag"
        :ok-title="$t('common.edit')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="update">
        <b-form-group
            class="internship-tag-name"
            label-for="internship-tag-name-input"
            :label="$t('common.name')">
            <b-form-input
                id="internship-tag-name-input"
                v-model="name"
                :placeholder="$t('internship.label_name')">
            </b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-internship-duration-tags-edit-modal-component',
    data() {
        return {
            tag: null,
            name: null,
            modal: false,
        };
    },
    methods: {
        update() {
            const postData = {
                id: this.tag.id,
                name: this.name,
            };
            this.alert.saving();
            this.axios.post(this.routes.internshipDurationTagUpdate(this.tag.id), postData).then(
                (response) => {
                    this.tag.update(response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );

            this.modal = false;
        },
        show(tag) {
            this.tag = tag;
            this.name = tag.name;
            this.modal = true;
        },
    },
};
</script>

<style scoped lang="scss">
.loading {
    display: flex;
    justify-content: center;
    color: $primary;
    font-size: 1.375rem;
}
</style>
